<template>
  <div>
    <div class="css-grid pay-invoice-form__row pay-invoice-form__row--header pay-invoice-form__row--error">
      <div></div>
      <div class="pay-invoice-view__cell pay-invoice-view__cell--header">Payment Error</div>
      <div></div>
    </div>

    <div class="panel">
      <div class="css-grid pay-invoice-form__row">
        <div></div>
        <div class="pay-invoice__message pay-invoice__message--error">
          We are unable to confirm with the payment processor whether or not your payment went through. 
          It's possible the payment might need to be submitted again, but out of an abundance of caution to avoid potential double payment, please contact our office at (360) 210-5658 or accounting@fuelmedical.com 
          and ask them to investigate.

          <br><br>
          Apologies for any inconvenience this has caused.
        </div>
        <div></div>
      </div>
    </div>

    <div class="pay-invoice__nav-row h-center-align">
      <button class="btn btn-primary" @click.prevent="nextStep">Pay Another Invoice</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ErrorMessageView',
    methods: {
      nextStep() {
        this.$store.dispatch('payInvoice/resetForm');
      },
    },
  }
</script>
